/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { PaymentServicesSDK } from '@adobe-commerce/payment-services-sdk';
import { state } from './state';

/**
 * Finalize Payment Services drop-in initialization with "ready" status.
 */
export function initializationSucceeded(paymentsSDK: {
  checkout: PaymentServicesSDK
  productDetail: PaymentServicesSDK
}) {
  state.value = { paymentsSDK, status: 'ready' };
}

/**
 * Finalize Payment Services drop-in initialization with "error" status.
 */
export function initializationFailed() {
  state.value = { paymentsSDK: null, status: 'error' };
}
